import { render } from "./carrusel3.vue?vue&type=template&id=d1b1e184&scoped=true"
import script from "./carrusel3.vue?vue&type=script&lang=js"
export * from "./carrusel3.vue?vue&type=script&lang=js"

import "./carrusel3.vue?vue&type=style&index=0&id=d1b1e184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b1e184"]])

export default __exports__